"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactMergeDataEnum = void 0;
var ContactMergeDataEnum;
(function (ContactMergeDataEnum) {
    ContactMergeDataEnum["MergeAndKeepExisting"] = "MergeAndKeepExisting";
    ContactMergeDataEnum["MergeAndOverride"] = "MergeAndOverride";
})(ContactMergeDataEnum = exports.ContactMergeDataEnum || (exports.ContactMergeDataEnum = {}));
